
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".short-text-container").forEach(function (container) {
      const content = container.querySelector(".short-text-content");
      const button = container.querySelector(".toggle-button");

      // Luo tilapäinen elementti selvittämään sisällön täysi korkeus
      const fullHeight = content.scrollHeight;
      const maxHeight = parseFloat(getComputedStyle(content).lineHeight) * 3;

      if (fullHeight <= maxHeight + 1) {
        // Ei tarvitse piilottaa -> piilotetaan nappi
        button.style.display = "none";
      } else {
        button.style.display= "inline-block";
        button.addEventListener("click", function (e) {
          e.preventDefault();
          container.classList.toggle("expanded");
          button.textContent = container.classList.contains("expanded")
            ? "Näytä vähemmän"
            : "Näytä lisää";
        });
      }
    });
  });